import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
export const isPredicateEmpty = (predicate)=>Object.values(predicate).every((value)=>value == null || Array.isArray(value) && value.length === 0);
export const isFilterEmpty = (filter)=>Object.entries(filter).every((param)=>{
        let [key, value] = param;
        return key === 'version' || value == null;
    });
export const setFilterField = (filter, key, value)=>{
    const { [key]: _omitted } = filter, rest = _object_without_properties(filter, [
        _to_property_key(key)
    ]);
    const next = value == null ? _object_spread_props(_object_spread({}, rest), {
        version: filter.version
    }) : _object_spread_props(_object_spread({}, rest), {
        version: filter.version,
        [key]: value
    });
    return isFilterEmpty(next) ? null : next;
};
const collapseGroupToArm = (filter, key, arm)=>{
    const { [key]: _omittedGroup } = filter, rest = _object_without_properties(filter, [
        _to_property_key(key)
    ]);
    const collapsed = _object_spread({}, rest, arm);
    return isFilterEmpty(collapsed) ? null : collapsed;
};
const activeGroupKey = (filter)=>filter.or != null ? 'or' : filter.and != null ? 'and' : null;
export const updateOrArm = (filter, index, arm)=>{
    var _filter_key;
    const key = activeGroupKey(filter);
    if (key == null) return undefined;
    const next = [
        ...(_filter_key = filter[key]) !== null && _filter_key !== void 0 ? _filter_key : []
    ];
    if (arm == null || isPredicateEmpty(arm)) {
        next.splice(index, 1);
    } else {
        next[index] = arm;
    }
    if (next.length === 1) return collapseGroupToArm(filter, key, next[0]);
    return setFilterField(filter, key, next.length === 0 ? undefined : next);
};
export const toggleGroupConnector = (filter)=>{
    if (filter.or != null && filter.or.length > 0) {
        const { or } = filter, rest = _object_without_properties(filter, [
            "or"
        ]);
        return _object_spread_props(_object_spread({}, rest), {
            and: or
        });
    }
    if (filter.and != null && filter.and.length > 0) {
        const { and } = filter, rest = _object_without_properties(filter, [
            "and"
        ]);
        return _object_spread_props(_object_spread({}, rest), {
            or: and
        });
    }
    return undefined;
};
export const clearGroupArms = (filter)=>{
    const key = activeGroupKey(filter);
    return key == null ? undefined : setFilterField(filter, key, undefined);
};
